import React from 'react';
import type {
  AttachmentClassificationResponse} from 'src/api/ProactApiClient';
import {
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {PageHeader} from 'src/design/organisms/PageHeader';
import {SidebarLinkAttachmentClassificationsAdmin} from 'src/app/layout/Sidebar/SidebarLinksConfig';
import {AttachmentClassificationTable} from 'src/app/attachment-classifications/AttachmentClassificationTable/AttachmentClassificationTable';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {useHasModulePermission} from 'src/shared/auth/useHasModulePermission';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import {useAppNavigate} from 'src/shared/hooks/useAppNavigate';

const AttachmentClassificationListPage: React.FC = () => {
  useSetDocumentTitle('Attachment Classifications');
  const navigate = useAppNavigate();

  const {hasPermission: hasCreatePermission} = useHasModulePermission({
    module: ModuleEnum.AttachmentClassifications,
    operation: PermissionOperationEnum.Create,
  });

  const handleNavigateToClassification = (
    obj: AttachmentClassificationResponse
  ) => {
    navigate(PathUtility.AttachmentClassificationView(obj.id));
  };

  const handleAddNew = () =>
    navigate(PathUtility.AttachmentClassificationCreate());

  return (
    <ContentWrapper>
      <PageHeader>
        <PageHeader.Title
          icon={SidebarLinkAttachmentClassificationsAdmin.icon}
          subtitle="Manage attachment classification labels">
          Attachment Classifications
        </PageHeader.Title>
      </PageHeader>
      <AttachmentClassificationTable
        identifier="attachment-classification-list-page"
        onViewRowClick={handleNavigateToClassification}
        onCreate={hasCreatePermission ? handleAddNew : undefined}
      />
    </ContentWrapper>
  );
};

routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.AttachmentClassification(),
  element: <AttachmentClassificationListPage />,
  module: ModuleEnum.AttachmentClassifications,
  operation: PermissionOperationEnum.View,
  isPrivate: true,
  allowGlobalAdminBypass: true,
});

export default AttachmentClassificationListPage;
